import React, { useState, useEffect } from 'react';

import Flash from './Flash';
import { setInterceptor } from './redux';


const FlashContainer = () => {

    const [messages, setMessages] = useState({});
    const [asArray, setAsArray] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const remove = id => {

        delete messages[id];

        setMessages(messages);
        setAsArray(Object.values(messages));
    };

    useEffect(() => {

        const addMessage = message => {

            messages[message.id] = {
                ...message,
                type: message.type || 'info',
                message: message.message
            };

            setMessages(messages);
            setAsArray(Object.values(messages));

            if (message.permanent) {
                return;
            }

            setTimeout(() => remove(message.id), 7000);
        };

        if (!loaded) {

            setInterceptor(addMessage);
            setLoaded(true);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaded]);


    return (
        <div id='flashes'>
            { asArray.map(message => (
                <Flash key={ message.id } { ...message } remove={ remove } />
            ))}
        </div>
    );
};

export default FlashContainer;
